import { Language } from '../utils/i18n';
import pt from './pt';
import User from '../view-model/users/User';

const importLang = async (name: string) => (await import(`./${name}`)).default as Language;

const languages = {
    pt: pt,
    en: () => importLang('en'),
    // es: () => importLang('es')
};

export default languages;

export type RealLanguages = keyof typeof languages;

export type Languages = RealLanguages | 'automatic';

export const languagesOptions: {
    key: Languages,
    title: string,
    value: User['language']
}[] = [{
    key: 'automatic',
    title: 'Automatic',
    value: 'automatic'
}, {
    key: 'pt',
    title: 'Português',
    value: 'portuguese'
}, {
    key: 'en',
    title: 'English',
    value: 'english'
// }, {
//     key: 'es',
//     title: 'Español',
//     value: 'spanish'
}];

export const languageMapper: { [key in User['language']]: Languages } & { [key in Languages]: User['language'] } = {
    portuguese: 'pt',
    english: 'en',
    // spanish: 'es',
    automatic: 'automatic',
    pt: 'portuguese',
    en: 'english',
    // es: 'spanish'
};
